import { Box, Chip, Divider, Typography } from '@mui/material';
import { MouseEvent } from 'react';
import { Link } from 'react-router-dom';

import { ReactComponent as UserIcon } from 'assets/user-black.svg';
import { ReactComponent as VerticalDotsIcon } from 'assets/vertical-dots.svg';
import ClientAvatar from 'components/shared/ClientAvatar';

import { formatDealAmount } from 'helper/short-currency';

import { muiStyles } from './muiStyles';
import styles from './styles.module.css';
import { getCardColor } from './utils';

const DealCard = ({
  data,
  onDrag,
  onSettingsClick,
}: {
  data: any;
  onDrag: (e: React.DragEvent, dealTitle: string) => void;
  onSettingsClick: (event: MouseEvent<SVGSVGElement>, deal: any) => void;
}) => {
  const {
    dealId,
    name,
    clientName,
    dealValue,
    ownerName,
    profilePicture,
    needsAttention,
    dealHealth,
    dealHealthName,
    amount,
  } = data;

  const { dotColor } = getCardColor(needsAttention, dealHealth, dealHealthName);

  return (
    <>
      <Link to={dealId} className={styles['card-link']}>
        <Box sx={muiStyles.card} draggable='true' onDragStart={(e) => onDrag(e, data.name)}>
          <Box sx={muiStyles.cardBody}>
            <Box sx={muiStyles.header}>
              <Typography variant='responsiveHeading4' sx={muiStyles.title}>
                {name}
              </Typography>

              <Box sx={muiStyles.optionsMenu}>
                <VerticalDotsIcon
                  className={styles['vertical-icon']}
                  onClick={(e: MouseEvent<SVGSVGElement>) => {
                    e.preventDefault();
                    onSettingsClick(e, data);
                  }}
                />
              </Box>
            </Box>

            <Box sx={muiStyles.clientCompanyContainer}>
              <ClientAvatar
                profilePicture={profilePicture}
                clientName={clientName}
                sx={muiStyles.clientAvatar}
              />
              <Typography variant='responsiveBody3'>{clientName}</Typography>
              <Box sx={muiStyles.dotDivider} />
              {/* Replace with API data when available */}
              <Typography variant='responsiveBody3'>Company Name</Typography>
            </Box>

            <Box sx={muiStyles.typeValueContainer}>
              {/* Replace with API data when available */}
              <Chip
                label={<Typography variant='responsiveLabel1'>Brand Deal</Typography>}
                sx={muiStyles.chip}
              />
              <Typography variant='responsiveHeading4'>
                {formatDealAmount(dealValue || amount)}
              </Typography>
            </Box>
          </Box>

          <Divider sx={muiStyles.divider} />

          <Box sx={muiStyles.metaSection}>
            <Box sx={muiStyles.userInfo}>
              <UserIcon width={'18px'} height={'18px'} />
              <Typography variant='responsiveBody3'>{ownerName}</Typography>
            </Box>
            <Box sx={muiStyles.statusIndicator}>
              <Box
                sx={{
                  width: '8px',
                  height: '8px',
                  borderRadius: '100%',
                  backgroundColor: dotColor,
                }}
              />
              <Typography variant='responsiveBody3'>5d</Typography>
            </Box>
          </Box>
        </Box>
      </Link>
    </>
  );
};

export default DealCard;
